import { createErrorSelector, createLoadingSelector } from "../../utils/reduxUtils";
import { RESERVATIONS_HIGHLIGHTS } from "../actions";

export const reservationsHighlightsSelector = (period: string) => (state: any) => state.reservationsHighlights[period];

export const reservationsHighlightsLoadingSelector = createLoadingSelector([RESERVATIONS_HIGHLIGHTS]);
export const reservationsHighlightsErrorSelector = createErrorSelector([RESERVATIONS_HIGHLIGHTS]);